import { render } from "./DDropdownSpacer.vue?vue&type=template&id=0843b476&scoped=true"
import script from "./DDropdownSpacer.vue?vue&type=script&lang=js"
export * from "./DDropdownSpacer.vue?vue&type=script&lang=js"

import "./DDropdownSpacer.vue?vue&type=style&index=0&id=0843b476&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0843b476"]])

export default __exports__